import { render, staticRenderFns } from "./ReZoning.vue?vue&type=template&id=0071a205&scoped=true"
import script from "./ReZoning.vue?vue&type=script&lang=js"
export * from "./ReZoning.vue?vue&type=script&lang=js"
import style0 from "./ReZoning.vue?vue&type=style&index=0&id=0071a205&prod&scoped=true&lang=css"
import style1 from "./ReZoning.vue?vue&type=style&index=1&id=0071a205&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071a205",
  null
  
)

export default component.exports